export default {
    HIPAA_TRAINING: "HIPAA",
    SECURITY_TRAINING: "SECURITY",
    PCI_TRAINING: "PCI",
    IR_TRAINING: "IR"
}


// WEBPACK FOOTER //
// ./src/utils/subModuleMapping.js